import { useEffect, useState } from 'react'

export function useFcmToken() {
  const [fcmToken, setFcmToken] = useState<string | null>(null)

  useEffect(() => {
    const handleFcmToken = (event: CustomEvent<{ token: string }>) => {
      const token = event.detail.token
      console.log('FCM Token received:', token)
      setFcmToken(token)
    }

    // Listen for the custom event from Flutter
    window.addEventListener('flutterFcmToken', handleFcmToken as EventListener)

    // Check if token is already available (in case Flutter set it before React mounted)
    if ((window as any).flutterFcmToken) {
      const token = (window as any).flutterFcmToken
      console.log('FCM Token already available:', token)
      setFcmToken(token)
    }

    return () => {
      window.removeEventListener(
        'flutterFcmToken',
        handleFcmToken as EventListener,
      )
    }
  }, [])

  return fcmToken
}
